export default __webpack_public_path__ + "static/pin-8210970acff9062a268bb87466ab7f54.png";